// src/pages/markets/board/card/TraderDetail.tsx
//
// Was a private helper inside SkillBlock. The conviction row needs the same
// per-trader popover, and SkillBlock is on its way out, so it moves here.

import { TraderStatsTooltip } from '../../components/TraderStatsTooltip';
import { useTraderProfileCache } from '../../api/useTraderProfileCache';
import { traderHref } from '../board/routes';

export function TraderDetail({ address }: { address: string }) {
    const profile = useTraderProfileCache(address);
    return (
        <TraderStatsTooltip
            address={address}
            profile={profile.data}
            loading={profile.loading}
            refreshing={profile.refreshing}
            error={profile.error}
            traderHref={traderHref(address)}
        />
    );
}